import { RECOMMENDATION_API_CONSTANTS } from "./constants";
import { RECOMMENDATIONS_API_TYPES } from "./recommendationsAPITypes";

export function RecommendationsAPIReducer(state, action) {
  const { type, payload } = action;

  const setCloseModal = () => {
    if (
      [
        RECOMMENDATION_API_CONSTANTS.TASK_STATUS_PENDING,
        RECOMMENDATION_API_CONSTANTS.TASK_STATUS_COMPLETE,
      ].includes(state.processData?.status)
    ) {
      return {
        ...state,
        isModalOpen: false,
      };
    }

    return {
      type: null,
      isModalOpen: null,
      attachmentsList: null,
      contentId: null,
      workflowNoContent: false,
      workflowOutput: null,
    };
  };

  const setChangeModal = () => {
    return {
      ...state,
      isModalOpen: payload,
    };
  };

  const setOpenAttachmentSelectorModal = () => {
    return {
      type: payload?.type,
      isModalOpen: payload?.isModalOpen,
      attachmentsList: payload?.attachmentsList,
      contentId: payload?.contentId,
      workflowNoContent: false,
    };
  };

  const setAddProcessData = () => {
    return {
      ...state,
      processData: payload,
      workflowNoContent: false,
      workflowOutput: null,
    };
  };

  const setEditProcessData = () => {
    return {
      ...state,
      processData: { ...state.processData, ...payload.data },
    };
  };

  const setStopCurrentProcessData = () => {
    return {
      ...state,
      processData: { ...state.processData, contentId: null, status: payload },
    };
  };

  const setShowProcessStatusCard = () => {
    return {
      ...state,
      showProcessStatusCard: payload,
    };
  };

  const setWorkflowOutput = () => {
    return {
      ...state,
      workflowOutput: payload,
      workflowNoContent: false,
    };
  };

  const setWorkflowNoContent = () => {
    return {
      ...state,
      workflowNoContent: true,
      workflowOutput: null,
    };
  };

  const resetWorkflowState = () => {
    return {
      ...state,
       processData: null,
      workflowOutput: null,
      workflowNoContent: false,
      showProcessStatusCard: false,
      isModalOpen: null,
    };
  };

  const setStateReducerTypes = {
    [RECOMMENDATIONS_API_TYPES.SET_OPEN_ATTACHMENT_SELECTOR_MODAL]:
      setOpenAttachmentSelectorModal,
    [RECOMMENDATIONS_API_TYPES.SET_CLOSE_MODAL]: setCloseModal,
    [RECOMMENDATIONS_API_TYPES.SET_CHANGE_MODAL]: setChangeModal,
    [RECOMMENDATIONS_API_TYPES.SET_ADD_PROCESS_DATA]: setAddProcessData,
    [RECOMMENDATIONS_API_TYPES.SET_EDIT_PROCESS_DATA]: setEditProcessData,
    [RECOMMENDATIONS_API_TYPES.SET_STOP_CURRENT_PROCESSING]:
      setStopCurrentProcessData,
    [RECOMMENDATIONS_API_TYPES.SET_SHOW_PROCESS_STATUS_CARD]:
      setShowProcessStatusCard,
    [RECOMMENDATIONS_API_TYPES.SET_WORKFLOW_OUTPUT]:
      setWorkflowOutput,
    [RECOMMENDATIONS_API_TYPES.SET_WORKFLOW_NO_CONTENT]:
      setWorkflowNoContent,
    [RECOMMENDATIONS_API_TYPES.RESET_WORKFLOW_STATE]:
      resetWorkflowState,
  };

  return setStateReducerTypes[type]?.() || state;
}
